import { Link, useParams } from 'react-router-dom';
import { getModuleEntryBySlug } from '@/config/moduleEntries';
import { moduleAdminPath } from '@/config/moduleDefaults';
import { PageHeader } from '@/components/layout/PageHeader';
import LockIcon from '@mui/icons-material/Lock';

const MODULE_LABELS: Record<string, string> = {
  hr: 'HR & Attendance',
  payroll: 'Payroll',
  finance: 'Finance',
  crm: 'CRM',
  delivery: 'Delivery',
  ecommerce: 'E-Commerce',
  analytics: 'Analytics',
  loyalty: 'Loyalty',
  social: 'Social Media',
  desk: 'Desk / Helpdesk',
  projects: 'Projects & Work Management',
};

export function LockedModulePage() {
  const { moduleKey } = useParams<{ moduleKey: string }>();
  const label = MODULE_LABELS[moduleKey ?? ''] ?? 'This module';
  const entry = moduleKey ? getModuleEntryBySlug(moduleKey) : undefined;
  const subscriptionPath = entry
    ? moduleAdminPath(entry.erpModule, 'subscription')
    : '/pos/subscription';

  return (
    <div>
      <PageHeader title={`${label} — locked`} />
      <div className="card mx-auto max-w-lg p-10 text-center">
        <LockIcon className="mx-auto text-5xl text-slate-400" />
        <h2 className="mt-4 text-xl font-semibold">Module locked</h2>
        <p className="mt-2 text-slate-600 dark:text-slate-400">
          Upgrade your subscription to unlock {label} and enable it for your organization.
        </p>
        <Link to={subscriptionPath} className="btn-primary mt-6 inline-block">
          View subscription &amp; plans
        </Link>
      </div>
    </div>
  );
}

